import { useContext } from "react";
import { ResourceContext } from "./ResourceProvider";

export default function useResource() {
    return useContext(ResourceContext);
};
